





import Vue from 'vue';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { editMutations, actions } from '../../store/types';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'OzakazkaVozidloSelect',
	components: { VozidloSelect: Vozidlo.components.Select },
	props: {
		disabled: { type: Boolean, default: undefined },
		storeUri: { type: String, default: null },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				vozidlo: `${this.storeUri}/${editMutations.OZAKAZKA_VOZIDLO_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				vozidlo: `${this.storeUri}/${actions.VOZIDLO_CHANGE}`,
			};
		},
		oZakazkaFilter(): object {
			return {
				VozidloId: this.VozidloId,
				Spz: this.VozidloIdSpz,
				VozidloKonId: this.VozidlokonId,
				Ozakazka: true,
				WorkshopId: this.ProvozovnaId ? this.ProvozovnaId : this.loggedUser.PracovnikProvSelect,
			};
		},
		spzCmp: {
			get(): string | undefined {
				if (!this.VozidloId) {
					return (!this.VozidlokonId) ? '' : undefined;
				}

				return this.VozidloIdSpz!;
			},
			set(value: string | null) {
				this.VozidloIdSpz = value;
				this.$emit('update:spz');
			},
		},
		VozidloText(): string | null {
			return this.VozidloId ? this.VozidloIdText : this.VozidlokonIdText;
		},
	},
});
